import type { Properties } from 'csstype'
import React from 'react'
import styled from 'styled-components'

import { Translate } from '@hozana/intl/Translate'
import { useDispatch } from '@hozana/redux/hooks'
import type { TResponsiveProps } from '@hozana/styling/responsive'
import { QA } from '@hozana/tests/constants'

import { Icon } from 'elements/media/Icon'
import { Ellipsis, TEllipsisProps } from 'elements/text/Ellipsis'
import { Text } from 'elements/text/Text'

import { ICON } from 'config/icons'
import { openPopin } from 'general/actions'
import { POPINS } from 'general/managers/popins/constants'

import { getCommunityMembers, getCommunityMembersText } from 'modules/community/functions'

import type { TCommunity } from '../types'

const StyledEllipsis = styled(Ellipsis)<{ openList?: boolean }>`
  ${(props) =>
    props.openList &&
    `
  &:focus,
  &:hover {
    color: ${props.theme.colors.orange};
  }
  `}
`

const responsiveProps = {
  p: 'padding',
} as const

export type TCommunityMembersProps = {
  community: TCommunity
  align?: Properties['textAlign']
  openMembersList?: boolean
  noEllipsis?: boolean
} & TEllipsisProps &
  TResponsiveProps<typeof responsiveProps>

/**
 * ### CommunityMembers ###
 */
export const CommunityMembers: TFCC<TCommunityMembersProps> = ({
  community,
  openMembersList = true,
  noEllipsis = false,
  align = 'left',
  fontSize = '1em',
  p = '0',
  ...otherProps
}) => {
  const dispatch = useDispatch()
  const nbMembers = getCommunityMembers(community)
  const communityMembersText = getCommunityMembersText(community)
  const openList = openMembersList && nbMembers > 0

  return (
    <StyledEllipsis
      as={openList && 'button'}
      openList={openList}
      wrap={noEllipsis}
      color="yellow"
      onClick={() => openList && dispatch(openPopin(POPINS.CommunityMembersListPopin, { communityId: community.id }))}
      data-testid={QA.COMMUNITY_COMMON.NB_MEMBERS}
      style={{ textAlign: align }}
      fontSize={fontSize}
      p={p}
      {...otherProps}
    >
      <Icon name={ICON.CONTACTS} size="1.3em" vAlign="text-bottom" m="0 8px 0 0" color="yellow" />
      <Text vAlign="initial" inline>
        <Translate values={{ count: nbMembers }}>{communityMembersText}</Translate>
      </Text>
    </StyledEllipsis>
  )
}
